import { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { REGION_META, REGION_ORDER } from "./constants";

export default function ProvinceAccordion({
  provincesByRegion,
  regions = REGION_ORDER,
  activeCode,
  onSelect,
}) {
  const [open, setOpen] = useState(regions.length === 1 ? regions[0] : "MN");

  return (
    <div className="xoso-province">
      {regions.map((region) => {
        const items = provincesByRegion?.[region] || [];
        const isOpen = open === region;
        return (
          <div key={region} className={`xoso-province__group${isOpen ? " is-open" : ""}`}>
            <button
              type="button"
              className={`xoso-province__btn${isOpen ? " is-open" : ""}`}
              onClick={() => setOpen(isOpen ? "" : region)}
              aria-expanded={isOpen}
            >
              <span className="xoso-province__btn-label">{REGION_META[region].label}</span>
              <span className="xoso-province__count">{items.length}</span>
              <ChevronDownIcon className="xoso-province__chevron" />
            </button>
            <ul className={`xoso-province__list${isOpen ? " is-open" : ""}`} hidden={!isOpen}>
              {items.map((p) => (
                <li key={p.code} className="xoso-province__item">
                  <button
                    type="button"
                    title={p.name}
                    className={`xoso-province__link${activeCode === p.code ? " is-active" : ""}`}
                    onClick={() => onSelect(p)}
                  >
                    <span className="xoso-province__name">{p.name}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
